/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from 'pinia';
import Axios from '@auth/vue-share/utility/axios';
import { useApplicationStore } from '@/stores/application';

export const useActivationCodeStore = defineStore('activationCode', {
    state: () => ({
        activation_codes: undefined
    }),
    getters: {
        getActivationCodes: (state) => state.activation_codes
    },
    actions: {
        fetchActivationCodes() {
            const applicationStore = useApplicationStore();
            applicationStore.setLoading(true);
            Axios.get('activation/codes', '/api/activation').then((response) => {
                this.activation_codes = response.data.data;
                applicationStore.setLoading(false);
            });
        }
    }
});
